<h2 mat-dialog-title>Verwijder</h2>
<hr />
<mat-dialog-content><p>Weet u zeker dat u dit wilt verwijderen?</p></mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button color="primary" (click)="cancel()" [mat-dialog-close]="false">Nee</button>
  <button mat-flat-button color="accent" (click)="close()" [mat-dialog-close]="data">Ja</button>
</mat-dialog-actions>
